"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicInfrastructure = void 0;
const CardName_1 = require("../../CardName");
const Tags_1 = require("../Tags");
const PreludeCard_1 = require("../prelude/PreludeCard");
const CardRenderer_1 = require("../render/CardRenderer");
const PlaceMoonRoadTile_1 = require("../../moon/PlaceMoonRoadTile");
const CardRenderItem_1 = require("../render/CardRenderItem");
class BasicInfrastructure extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.BASIC_INFRASTRUCTURE,
            tags: [Tags_1.Tags.MOON],
            metadata: {
                description: 'Place a road tile on the Moon and raise the Logistics Rate 1 step. Gain 1 trade fleet.',
                cardNumber: 'MP3',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.moonRoad().secondaryTag(CardRenderItem_1.AltSecondaryTag.MOON_LOGISTICS_RATE).tradeFleet();
                }),
            },
        });
    }
    ;
    play(player) {
        player.game.defer(new PlaceMoonRoadTile_1.PlaceMoonRoadTile(player));
        player.increaseFleetSize();
        return undefined;
    }
}
exports.BasicInfrastructure = BasicInfrastructure;
//# sourceMappingURL=BasicInfrastructure.js.map